import { Component, Input } from '@angular/core';
import {SlideshowService} from '../../slideshow.service';

@Component({
    selector: 'content-quiz',
    templateUrl: 'content-quiz.component.html'
})
export class PreviewContentQuizComponent {
    intro;
    questions = [];
    outro;

    @Input('device') device;

    constructor(private slideshow: SlideshowService) {
        const slides = this.slideshow.slides;
        this.intro = slides[0];
        const lastIndex = slides.length - 1;
        this.outro = slides[lastIndex];
        this.questions = slides.filter(item => !item.intro && !item.outro);
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/preview/content-quiz.component.ts